<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-list"></i>
          ລາຍການອິນວອຍ
          <span class="countTotal">({{ count }})</span>
        </h4>
      </div>

    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-2">
          <div class="control">
            <label class="label">ຈາກວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="start_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="start_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">ຫາວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="end_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="end_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">ສະຖານະ:</label>
            <div class="select">
              <select class="input" v-model="invoice_status" @change="FetchData()">
                <option value="">ທັງໝົດ</option>
                <option value="pending">pending</option>
                <option value="success">success</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-2" style="margin-top: 3px">
          <vs-button
              v-if="listInvoices.length !== 0"
              ref="button" flat
              @click="exportExcel('all', null)"
              class="form-btn-loading"
              :loading="loading">
            export excel
          </vs-button>
        </div>
      </div>
    </div>
    <hr :style="{marginTop: '-10px'}">
    <div class="center" :style="{marginTop: '-10px'}">
      <vs-table>
        <template #thead>
          <vs-tr>
            <vs-th>ຈຳນວນທັງໝົດ</vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr :is-selected="true">
            <vs-td>{{ FormatPrice(total) }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th></vs-th>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ວັນທິສ້າງ</vs-th>
            <vs-th>ລາຍລະອຽດອິນວອຍ</vs-th>
            <vs-th>ເລກອິນວອຍ</vs-th>
            <vs-th>ຮ້ານຄ້າຫຼັກ</vs-th>
            <vs-th>ຈຳນວນ</vs-th>
            <vs-th>ສະຖານະ</vs-th>
            <vs-th>ວັນທີໂອນ</vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              :data="invoice"
              v-for="(invoice, index) in $vs.getPage(listInvoices, page, max)">
            <vs-td style="text-align: right; width: 100px">
              <div class="group-icon">
                <vs-button
                    v-if="invoice.status === 'pending' && $can('marketinghelper')"
                    circle icon flat
                    @click="OpenModalEdit(invoice.id)">
                  <i class="fad fa-pen"></i>
                </vs-button>
                <vs-button circle icon flat
                           @click="$router.push({name: 'list.shop.invoice.detail', params:{id: invoice.id}})">
                  <i class="fad fa-eye"></i>
                </vs-button>
                <vs-button
                    v-if="$can('marketinghelper')"
                    circle icon flat
                    @click="exportExcel(invoice.id, invoice.shop_name)">
                  <i class="fad fa-print"></i>
                </vs-button>
                <vs-button
                    v-if="invoice.status === 'pending' && $can('marketinghelper')"
                    circle icon flat
                    @click="OpenModalDelete(invoice.id)">
                  <i style="color: red" class="fad fa-trash"></i>
                </vs-button>
              </div>
            </vs-td>
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>{{ moment(invoice.created_at).format('DD/MM/YYYY HH:mm') }}</vs-td>
            <vs-td>{{ invoice.invoice_name }}</vs-td>
            <vs-td>{{ invoice.invoice_number }}</vs-td>
            <vs-td>{{ invoice.shop_name }}</vs-td>
            <vs-td>{{ FormatPrice(invoice.amount) }}</vs-td>
            <vs-td v-if="invoice.status === 'pending'" style="color: red">{{ invoice.status }}</vs-td>
            <vs-td v-else style="color: green">{{ invoice.status }}</vs-td>
            <vs-td v-if="invoice.success_at">{{ moment(invoice.success_at).format('DD/MM/YYYY HH:mm') }}</vs-td>
            <vs-td v-else></vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"></pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>
    <ModalEdit>
      <template v-slot="{ close }">
        <editInvoice @close="close"
                     :invoiceId="invoice_id"
                     @success="FetchData()"/>
      </template>
    </ModalEdit>
    <ModalDelete>
      <template v-slot="{ close }">
        <confirm-delete-invoice @close="close"
                     :invoiceId="invoice_id"
                     @success="FetchData()"/>
      </template>
    </ModalDelete>
  </div>
</template>
<script>
import Loading from "@/views/Loading";
import {mapActions} from "vuex";
import pagination from '@/Plugins/Paginations/Pagination';
import DatePicker from "vue2-datepicker";
import moment from "moment";
import editInvoice from "@views/ShopInvoicePoint/Dialog/editInvoice";
import confirmDeleteInvoice from "@views/ShopInvoicePoint/Dialog/confirmDeleteInvoice";
export default {
  components: {
    Loading,
    pagination,
    DatePicker,
    editInvoice,
    confirmDeleteInvoice
  },

  data: () => ({
    invoice_status: '',
    invoice_id: '',
    page: 1,
    max: 10,
    start_date: moment(new Date()).format('YYYY-MM-DD'),
    end_date: moment(new Date()).format('YYYY-MM-DD'),
    isLoading: false,
    listInvoices: [],
    // Pagination
    count: 0,
    total: 0,
    offset: 10,
    limit_page: 10,
    pagination: {},
    //Export
    actualSelectedItems: [],
    isSelecting: false,
    pageInvoices: [],
    loading: false,
    checkedAll: false,
  }),
  methods: {
    exportExcel(id, shop_name) {
      const loading = this.BtnLoading();
      this.loading = true;
      this.$http.post(`export/shop/invoice/${id}`, {
        start_date: this.start_date,
        end_date: this.end_date,
        status: this.invoice_status
      }, {responseType: 'blob'}).then((res) => {
        const fileUrl = window.URL.createObjectURL(new Blob([res.data]))
        const fileLink = document.createElement('a');
        fileLink.href = fileUrl;
        if (id === 'all') {
          if (this.start_date === this.end_date) {
            fileLink.setAttribute('download', 'ລາຍການອິນວອຍຮ້ານຄ້າທັງໝົດວັນທີ ' + moment(this.start_date).format('DD-MM-YYYY') + '.xlsx');
          } else {
            fileLink.setAttribute('download', 'ລາຍການອິນວອຍຮ້ານຄ້າທັງໝົດວັນທີ ' + moment(this.start_date).format('DD-MM-YYYY') + 'ຫາ' + moment(this.end_date).format('DD-MM-YYYY') + '.xlsx');
          }
        } else {
          if (this.start_date === this.end_date) {
            fileLink.setAttribute('download', `ລາຍການອິນວອຍ ${shop_name} ວັນທິ ` + moment(this.start_date).format('DD-MM-YYYY') + '.xlsx');
          } else {
            fileLink.setAttribute('download', `ລາຍການອິນວອຍ ${shop_name} ວັນທີ ` + moment(this.start_date).format('DD-MM-YYYY') + 'ຫາ' + moment(this.end_date).format('DD-MM-YYYY') + '.xlsx');
          }
        }

        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        this.loading = false;
        loading.close()
      }).catch(() => {
        this.loading = false;
        loading.close()
      });
    },

    FormatPrice(price) {
      let p = (parseInt(price) || 0).toFixed(2).split(".");
      return p[0].split("").reverse().reduce(function (acc, price, i) {
        return price === "-" ? acc : price + (i && !(i % 3) ? "," : "") + acc;
      }, "");
    },
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },
    disableDateCustomer(date) {
      const fixDay = moment('2021-08-01 00:00:00');
      return date < fixDay;
    },
    OpenModalEdit(invoiceId) {
      this.invoice_id = JSON.parse(JSON.stringify(invoiceId));
      this.$store.commit('modalEdit_State', true);
    },
    OpenModalDelete(invoiceId) {
      this.invoice_id = JSON.parse(JSON.stringify(invoiceId));
      this.$store.commit('modalDelete_State', true);
    },
    FetchData() {
      this.isLoading = true;
      this.fetchInvoiceItemsResponse().then((res) => {
        if (!res.data.error) {
          setTimeout(() => {
            this.listInvoices = res.data.data.data.data;
            this.total = res.data.data.total;
            this.count = res.data.data.data.total;
            this.pagination = res.data.data.data;
          }, 300);
        }
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },

    fetchInvoiceItemsResponse(options = {}) {
      const {current_page, per_page} = options;
      return this.$http.get('list/shop/invoice', {
        params: {
          start_date: this.start_date,
          end_date: this.end_date,
          status: this.invoice_status,
          page: current_page ?? this.pagination.current_page,
          per_page: per_page ?? this.limit_page,
        }
      })
    },

    ...mapActions({
      LogoutUser: "User/destroyToken",
    }),

    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.table,
        scale: "1",
        background: "primary",
        opacity: 1,
        color: "#195BFF",
      });
    },
  },
  created() {
    this.FetchData();
  },
  watch: {
    'start_date': function () {
      this.FetchData();
    },
    'end_date': function () {
      this.FetchData();
    },
  }
};
</script>
<style lang="scss" scope>
.container {
  margin-top: 40px;

  .title-login {
    font-size: 20px;
    color: $primary-color;
  }
}

.fit-width {
  white-space: nowrap;
}

.vs-table__td,
.vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
  width: 1px !important;
}

</style>
